import { Navigate } from "react-router-dom";
import { PATHS } from "@/lib/router";
import { useAuthStore } from "@/features/auth/hooks";
import { observer } from "mobx-react-lite";

// Public route wrapper - redirects to dashboard if already authenticated
export const PublicRoute = observer(({ children }) => {
  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) {
    // Redirect to dashboard if already authenticated
    return <Navigate to={PATHS.DASHBOARD} replace />;
  }

  return children;
});
